export default __webpack_public_path__ + "static/media/logo-cheerz-app.cccfb48b.png";